export default __webpack_public_path__ + "static/media/image22746.93f9c359.png";